import { motion } from 'framer-motion';

interface AnimatedSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  trackClassName?: string;
  thumbClassName?: string;
  thumbCheckedX?: number;
}

export function AnimatedSwitch({
  checked,
  onChange,
  disabled = false,
  className,
  trackClassName = 'w-10 h-5',
  thumbClassName = 'w-4 h-4',
  thumbCheckedX = 20,
}: AnimatedSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${className ?? ''}`}
    >
      <motion.div
        className={`${trackClassName} rounded-full p-0.5 flex`}
        animate={{ backgroundColor: checked ? 'hsl(var(--primary))' : 'hsl(var(--muted-foreground) / 0.4)' }}
        transition={{ duration: 0.3 }}
      >
        <motion.div
          className={`${thumbClassName} bg-white rounded-full shadow-sm`}
          animate={{ x: checked ? thumbCheckedX : 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
      </motion.div>
    </button>
  );
}
